import {LazyLoad, ScrollToLazy} from '../shared/';
import Lightbox from '../lightbox/_lightbox.js';
import ModuleLoader from './../modules/module.loader.js';
import {
  LAZYMODULES
} from '../app.config.js';
import Filters from './filters.js';
import Modal from '../modal/_modal.js';
import {
  MODAL
} from '../app.config.js';

export default class Routing {

  loadLazyModules(context) {
    const container = context ? context.container : document.body;
    this.modules = [];
    this.images = [];
    this.modules = ModuleLoader.moduleLoader(container);
    this.initScrollTo(this.modules);
    !LAZYMODULES && ModuleLoader.loadAllModules(this.modules, this.onModulesLoaded(container));
    this.images = new LazyLoad(container, this.onImageLoaded.bind(this));
    this.lightbox = Lightbox.init(container);
    this.modal = MODAL && Modal.init(container);
  }

  onImageLoaded() {
    window.client.scroller.refresh();
  }

  onModulesLoaded(context) {
    if (this.filters && this.filters.loaded) {
      this.filters.restart(context);
    }
    window.client.scroller.refresh();
  }

  initFWP() {
    this.filters = new Filters(document.body, window.FWP);
    this.filters.firstLoad = true;
    this.filters.init();
  }

  init(header, scroller) {
    if (window.FWP) this.initFWP();
    this.loadLazyModules();
  }

  initScrollTo(modules) { //download every modules before scroll to section
    const options = {
      selectors: {
        buttonAttr: 'data-scrollto-button',
        targetAttr: 'data-component-id'
      },
      settings: {
        offset: 40 //40px offset top from section
      }
    }
    this.scrollToItems = Array.from(
      document.querySelectorAll(`[${options.selectors.buttonAttr}]`)).map((node, index) => new ScrollToLazy(
      node,
      modules,
      options
    ));
  }
}
